import { useState } from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { useLanguage } from '../context/LanguageContext'

const NAVY = '#002E53'
const GOLD = '#C5A059'

export default function ValuationPage() {
  const { t, langMeta, isRTL } = useLanguage()
  const FONT = `"${langMeta.font}", sans-serif`
  const [form, setForm] = useState({ name: '', phone: '', email: '', propertyType: '', location: '', bedrooms: '', size: '' })
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const propertyDetails = `${form.propertyType} in ${form.location}${form.bedrooms ? `, ${form.bedrooms} Beds` : ''}${form.size ? `, ${form.size} Sq.Ft` : ''}`
      await fetch('/api/admin/services', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          form: {
            fullName: form.name,
            phone: form.phone,
            email: form.email,
            propertyDetails,
            serviceRequested: 'Property Valuation Request',
            serviceId: 'valuation'
          }
        })
      })
      setSubmitted(true)
    } catch {
      alert("Failed to submit request. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  const inputStyle = {
    width: '100%', padding: '14px 16px', border: '1.5px solid #dde2ea',
    borderRadius: '10px', fontFamily: FONT, fontSize: '14px', color: NAVY,
    background: '#fff', outline: 'none', boxSizing: 'border-box'
  }

  const selectStyle = {
    ...inputStyle,
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23002E53' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: isRTL ? 'left 16px center' : 'right 16px center',
    backgroundSize: '16px 16px',
    paddingRight: isRTL ? '16px' : '40px',
    paddingLeft: isRTL ? '40px' : '16px',
    cursor: 'pointer'
  }

  const labelStyle = { display: 'block', fontFamily: FONT, fontSize: '13px', fontWeight: 600, color: NAVY, marginBottom: '8px' }

  return (
    <div style={{ fontFamily: FONT }} dir={isRTL ? 'rtl' : 'ltr'}>
      <Navbar />

      <div style={{
        background: `linear-gradient(135deg, ${NAVY} 0%, #001a33 60%, #0a2d4a 100%)`,
        padding: '150px 20px 80px', textAlign: 'center', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', top: '-80px', right: isRTL ? 'auto' : '-80px', left: isRTL ? '-80px' : 'auto', width: '380px', height: '380px', borderRadius: '50%', background: `${GOLD}15`, pointerEvents: 'none' }} />
        <h1 style={{ fontFamily: FONT, fontSize: 'clamp(30px, 4vw, 52px)', fontWeight: 700, color: '#fff', margin: '0 0 16px' }}>
          {t('valuation.heroTitle')}
        </h1>
        <p style={{ fontFamily: FONT, fontSize: '16px', color: 'rgba(255,255,255,0.72)', maxWidth: '580px', margin: '0 auto', lineHeight: '1.7' }}>
          {t('valuation.heroDesc')}
        </p>
      </div>

      <div style={{ background: '#f4f7fb', padding: '80px 20px' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto', background: '#fff', borderRadius: '16px', padding: '40px', boxShadow: '0 4px 24px rgba(0,46,83,0.06)' }}>
          {submitted ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <div style={{ fontSize: '48px', marginBottom: '20px' }}>✅</div>
              <h2 style={{ color: NAVY, margin: '0 0 10px' }}>{t('valuation.successTitle')}</h2>
              <p style={{ color: '#5a6577', marginBottom: '30px' }}>{t('valuation.successDesc')}</p>
              <button onClick={() => setSubmitted(false)} style={{ background: NAVY, color: '#fff', padding: '12px 24px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>{t('valuation.submitAnother')}</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={labelStyle}>{t('valuation.fullName')}</label>
                  <input required type="text" style={inputStyle} placeholder={t('valuation.fullName').replace(' *', '')} value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
                </div>
                <div>
                  <label style={labelStyle}>{t('valuation.phone')}</label>
                  <input required type="tel" style={inputStyle} placeholder="+971 50 000 0000" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
                </div>
                <div>
                  <label style={labelStyle}>{t('valuation.email')}</label>
                  <input type="email" style={inputStyle} placeholder="you@example.com" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
                </div>
                <div>
                  <label style={labelStyle}>{t('valuation.propType')}</label>
                  <select required style={selectStyle} value={form.propertyType} onChange={e => setForm({...form, propertyType: e.target.value})}>
                    <option value="">{t('valuation.selectType')}</option>
                    <option value="Apartment">Apartment</option>
                    <option value="Villa">Villa</option>
                    <option value="Townhouse">Townhouse</option>
                    <option value="Penthouse">Penthouse</option>
                    <option value="Plot">Plot</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>{t('valuation.location')}</label>
                  <input required type="text" style={inputStyle} placeholder={t('valuation.locPlaceholder')} value={form.location} onChange={e => setForm({...form, location: e.target.value})} />
                </div>
                <div>
                  <label style={labelStyle}>{t('valuation.bedrooms')}</label>
                  <select style={selectStyle} value={form.bedrooms} onChange={e => setForm({...form, bedrooms: e.target.value})}>
                    <option value="">{t('valuation.select')}</option>
                    <option value="Studio">Studio</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5+">5+</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>{t('valuation.area')}</label>
                  <input type="number" style={inputStyle} placeholder={t('valuation.areaPlaceholder')} value={form.size} onChange={e => setForm({...form, size: e.target.value})} />
                </div>
              </div>

              <button type="submit" disabled={loading} style={{
                width: '100%', marginTop: '30px', background: loading ? '#8a9ab0' : NAVY,
                color: '#fff', padding: '16px', borderRadius: '10px', border: 'none',
                fontWeight: 'bold', fontSize: '16px', cursor: loading ? 'not-allowed' : 'pointer'
              }}>
                {loading ? t('valuation.submitting') : t('valuation.submit')}
              </button>
            </form>
          )}
        </div>
      </div>

      <Footer />
    </div>
  )
}
